
































import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import firebase from 'firebase/app'
import dayjs from 'dayjs'
import MainMixin from '../mixins/MainMixin'
import EventBus from '../event-bus'


@Component({
  components: {
  },
})
export default class Home extends Mixins(MainMixin) {
  test22() {
    console.log('user is: ')
  }

  logout() {
    firebase.auth().signOut()
  }
}
